import { createApiInstance } from "./apiInstance";
import { apiCall } from "./apiCall";
import { Method } from "axios";

const helaPayApi = createApiInstance(process.env.REACT_APP_HELAPAY_BASE_URL || "https://payment-helapay.onepay.lk");

export const helaPayApiCall = (
  url: string,
  method: Method = 'GET',
  data: any = null,
  header: string | null = null,
  encrypt: boolean = false
): Promise<any> => {
  return apiCall(helaPayApi, url, method, data, header, encrypt,false);
};
